"use client";

import { Badge } from "@/components/ui/badge";
import { Building2, Globe, MapPin } from "lucide-react";
import { motion } from "motion/react";
import { GridSvg } from "@/components/gridSvg";
import Image from "next/image";

export default function OurVision() {
  return (
    <section className="wrapper relative py-14">
      <GridSvg />
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Badge>Our Vision</Badge>
        <h1 className={"text-4xl font-bold mt-4"}>
          Powered by <br />
          <span className={"text-primary"}>Technology</span>
        </h1>
        <div className={"grid grid-cols-1 md:grid-cols-2 gap-5 mt-5"}>
          <div>
            <p
              className={
                "italic pl-5 border-l-4 font-semibold border-l-primary text-lg"
              }
            >
              &quot;Promote, develop and leverage quality goods and services
              that are powered by &apos;technology&apos;.&quot;
            </p>
            <div className="space-y-6 mt-10">
              <h3 className="text-xl font-semibold text-foreground">
                Our Global Presence
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4 p-4 square-gradient-bg   bg-muted border">
                  <MapPin className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                  <div>
                    <div className="font-bold text-foreground">Head Office</div>
                    <div className="text-muted-foreground font-semibold">
                      Thimphu, Bhutan
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 square-gradient-bg   bg-muted border">
                  <Building2 className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                  <div>
                    <div className="font-bold text-foreground">Branches</div>
                    <div className="text-muted-foreground font-semibold">
                      Phuntsholing & Gelephu, Bhutan
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 square-gradient-bg   bg-muted border">
                  <Globe className="h-5 w-5 text-primary mt-1 flex-shrink-0" />
                  <div>
                    <div className="font-bold text-foreground">
                      International Presence
                    </div>
                    <div className="text-muted-foreground font-semibold">
                      Kolkata, Bangkok & Singapore
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Image
            src={
              "https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?cs=srgb&dl=pexels-pixabay-356056.jpg&fm=jpg"
            }
            alt={"Office"}
            width={500}
            height={500}
            className={"w-full h-full object-cover rounded"}
          />
        </div>
      </motion.div>
    </section>
  );
}
